import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'
import PatientFile from 'model/PatientFile'
import axios from 'axios'
const { server } = (window as any).config

export class PatientsFilesRepository extends WebRepository<PatientFile> {
  constructor() {
    super(new Api('patients_files'))
  }

  async search(patientId: string): Promise<PatientFile[]> {
    return super.search({
      selector: {
        $and: [
          {
            patientId: patientId,
          },
        ],
      },
      limit: 1,
    })
  }

  async searchUnCategorized(): Promise<PatientFile[]> {
    return super.search({
      selector: {
        category: {
          $exists: false,
        },
      },
      limit: 1,
    })
  }

  async searchAppointmentFiles(appointmentId: string): Promise<PatientFile[]> {
    return super.search({
      selector: {
        $and: [
          {
            appointmentId: appointmentId,
            category: { $in: ['referral', 'appointmentSummery'] },
          },
        ],
      },
      limit: 10,
    })
  }

  async searchAppointmentExamination(appointmentId: string): Promise<PatientFile[]> {
    return super.search({
      selector: {
        $and: [
          {
            appointmentId: appointmentId,
            category: 'examination',
          },
        ],
      },
      limit: 100,
    })
  }

  async searchAppointmentClinic(appointmentId: string): Promise<PatientFile[]> {
    return super.search({
      selector: {
        $and: [
          {
            appointmentId: appointmentId,
          },
          {
            category: {
              $ne: 'examination',
            },
          },
          {
            category: {
              $ne: 'referral',
            },
          },
          {
            category: {
              $ne: 'appointmentSummery',
            },
          },
        ],
      },
      limit: 10,
    })
  }

  async updateExamWithResults(patientFile: object, patientMedicalResult: object | undefined) {
    const result = await axios.post(server + '/patients_files/updateExamWithResults', {
      patientFile,
      patientMedicalResult,
    })

    return result
  }
}

export default new PatientsFilesRepository()
